<template>
  <span v-if="soloLectura">{{ nombreDelRol }}</span>
  <a v-else class="member-role-field__link" @click.prevent="alHacerClic">
    <span>{{ nombreDelRol }}</span>
    <i class="iconoir-nav-arrow-down"></i>
  </a>
</template>

<script>
/**
 * La celda de rol de la tabla de Miembros.
 *
 * Calcada de MemberRoleField del core (MIT) con UN cambio: como se busca el rol.
 * El suyo hace `row.permissions === 'ADMIN' ? 'ADMIN' : 'MEMBER'`, o sea que
 * cualquier rol que no sea Admin lo pinta como "Miembro". Con dos roles eso
 * daba igual; con el Lector convierte la columna en una mentira — la persona
 * es Lectora, el servidor la trata como Lectora, y la tabla dice "Miembro".
 *
 * Aqui se busca por el valor guardado, sin suponer que solo hay dos.
 */
export default {
  name: 'RolDeMiembro',
  props: {
    row: { type: Object, required: true },
    column: { type: Object, required: true },
  },
  emits: ['edit-role-context'],
  computed: {
    soloLectura() {
      const { additionalProps } = this.column
      return (
        additionalProps.userId === this.row.user_id ||
        !this.$hasPermission(
          'workspace_user.update',
          this.row,
          additionalProps.workspaceId
        )
      )
    },
    nombreDelRol() {
      // Membresia de supervision: solo les llega a los supervisores (ver
      // extras_mg/supervision/datos_de_miembro.py). El permiso es de admin.
      if (this.row.mg_supervision) return 'Supervisor (oculto)'
      const roles = this.column.additionalProps.roles || []
      const rol = roles.find((r) => r.uid === this.row.permissions)
      // Si el valor guardado no corresponde a ningun rol conocido se enseña tal
      // cual en vez de inventar uno: es raro, pero verlo es mejor que taparlo.
      return rol?.name || this.row.permissions || ''
    },
  },
  methods: {
    alHacerClic(event) {
      this.$emit('edit-role-context', {
        row: this.row,
        event,
        target: event.currentTarget,
        time: Date.now(),
      })
    },
  },
}
</script>
